import React from "react";
import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { IconExternalLink } from "@amzn/stencil-react-components/icons";
import { useChecklistArb } from "../../hooks/use-arb";
import { useAppSelector } from "../../reduxStore/reduxHooks";
import { getConfigData } from "../../reduxStore/slices/configSlice";
import { StatusEnum } from "@amzn/hvh-simple-hire-checklist-internal-api-common";

export const AssessmentButton = ({ status }: { status?: StatusEnum }) => {
  const bundle = useChecklistArb();
  const { hdeDetails } = useAppSelector(getConfigData);

  const translation = {
    viewAssessment: bundle.getMessage("Checklist-Assessment-Button-View"),
    completeAssessment: bundle.getMessage("Checklist-Assessment-Button-Complete"),
  };

  return (
    <Button
      variant={ButtonVariant.Primary}
      disabled={!hdeDetails?.assessment?.secureUrl}
      onClick={() => window.open(hdeDetails?.assessment?.secureUrl)}
    >
      {status === StatusEnum.COMPLETED ? translation.viewAssessment : translation.completeAssessment}
      <IconExternalLink />
    </Button>
  );
};
